export default __webpack_public_path__ + "static/media/notebook.6704a864.png";